import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconPanelRightLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.308 20.5c-.499 0-.925-.177-1.278-.53a1.742 1.742 0 0 1-.53-1.278V5.308c0-.499.177-.925.53-1.278.353-.353.78-.53 1.278-.53h13.384c.499 0 .925.177 1.278.53.353.353.53.78.53 1.278v13.384c0 .499-.177.925-.53 1.278-.353.353-.78.53-1.278.53H5.308ZM8 19V5H5.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v13.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096H8Zm1.5 0h9.192a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V5.308a.294.294 0 0 0-.096-.212.294.294 0 0 0-.212-.096H9.5v14Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconPanelRightLine;
